export { default } from './TabGroupBensServicos';
